import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import LgyModalDialog from 'app/components/util/lgy-modal-dialog/LgyModalDialog'
import { userSessionHeartbeat } from 'app/actions/currentUserActions'

class SessionTimeoutContainer extends React.Component {
  state = {
    timedOut: false,
    /* TODO: fetch the timeout warning seconds from server.  Currently set to 13 minutes */
    sessionTimeoutLength: 780 * 1000
  }

  componentDidMount() {
    this.interval = setInterval(this.checkTimedOut, 500)
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  }

  checkTimedOut = () => {
    if ((new Date(window.localStorage.getItem('latestResponse')) < (new Date() - this.state.sessionTimeoutLength))) {
      if (!this.state.timedOut && this.props.user) {
        this.setState({ timedOut: true })
      }
    } else if (!this.props.user || this.state.timedOut) {
      this.setState({ timedOut: false })
    }
  }

  render() {
    if (this.props.userTimedOut && !this.props.user) {
      return <Redirect to='/lgyhub/' />
    }

    return (
      <LgyModalDialog show={this.state.timedOut}>
        <div style={{ maxWidth: '350px' }} className='usa-grid'>
          <h4 style={{ textAlign: 'center' }}>Session Timeout</h4>
          <p className='usa-content'>
            Your session will expire in 2 minutes.  Click Continue to stay logged in.
          </p>
          <hr />
          <button className='usa-button' style={{ width: '100%' }} onClick={this.props.userSessionHeartbeat}>
            Continue
          </button>
        </div>
      </LgyModalDialog>
    )
  }
}

const mapStateToProps = state => ({
  user: state.currentUser.exists,
  userTimedOut: state.errorState.errors.some(error => error.error === 'Session Timeout')
})

const mapDispatchToProps = { userSessionHeartbeat }

export default connect(mapStateToProps, mapDispatchToProps)(SessionTimeoutContainer)
